import { render, staticRenderFns } from "./FileMove.vue?vue&type=template&id=62a036b3&scoped=true&"
import script from "./FileMove.vue?vue&type=script&lang=js&"
export * from "./FileMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a036b3",
  null
  
)

export default component.exports